export default "__VITE_ASSET__oIib8y6e__"